import { Box } from '@mui/material';
import { ControlledAutoComplete } from 'components/shared/ControlledFields';
import { t } from 'i18next';
import { Control } from 'react-hook-form';
import { styled } from '@mui/material/styles';

type ShowMoreFiltersProps = {
  control: Control<any>;
  employeeList: { empId: number; nameInformal: string }[] | undefined;
  requestReasonList: { id: number; name: string }[] | undefined;
  rosterFunctionOptions: { id: number; description: string }[] | undefined;
  employmentAgencies: { id: number; name: string }[] | undefined;
};

const StyledBox = styled(Box)({
  flexGrow: 1,
  minWidth: 200,
  maxWidth: 400
});

const ShowMoreFilters = ({
  control,
  employeeList,
  requestReasonList,
  rosterFunctionOptions,
  employmentAgencies
}: ShowMoreFiltersProps) => {
  return (
    <Box
      display="flex"
      flexWrap="wrap"
      gap={1}
      marginTop={0.5}
      marginBottom={1}
      maxWidth={1536}
    >
      <StyledBox>
        <ControlledAutoComplete
          disableSorting
          optionLabelProp="nameInformal"
          idProperty="empId"
          variant="outlined"
          control={control}
          name="employee"
          label={t('flexHistory.employeeList')}
          options={employeeList ?? []}
          fullWidth
        />
      </StyledBox>
      <StyledBox>
        <ControlledAutoComplete
          disableSorting
          optionLabelProp="name"
          idProperty="id"
          variant="outlined"
          control={control}
          name="reason"
          label={t('flexHistory.requestReason')}
          options={requestReasonList ?? []}
          fullWidth
        />
      </StyledBox>
      <StyledBox>
        <ControlledAutoComplete
          disableSorting
          optionLabelProp="description"
          idProperty="id"
          variant="outlined"
          control={control}
          name="rosterFunction"
          label={t('flexHistory.rosterFunction')}
          options={rosterFunctionOptions ?? []}
          fullWidth
        />
      </StyledBox>
      <StyledBox>
        <ControlledAutoComplete
          disableSorting
          optionLabelProp="name"
          idProperty="id"
          variant="outlined"
          control={control}
          name="agency"
          label={t('flexHistory.employmentAgencies')}
          options={employmentAgencies ?? []}
          fullWidth
        />
      </StyledBox>
    </Box>
  );
};

export default ShowMoreFilters;
